const React = require('react');
const TextField = require('@material-ui/core/TextField').default;


module.exports = ({
  className,
  helperText,
  limit,
  ...props
}) => {
  const length = props.value.length;
  const inputProps = {
    ...(props.inputProps || {}),
  };

  if (limit) {
    inputProps.maxLength = limit;
  }


  return (
    <div className={'rlv ' + (className || '')}>
      <TextField
        margin="none"
        variant="outlined"
        {...props}
        inputProps={inputProps}
        InputLabelProps={{
          shrink: true,
          ...(props.InputLabelProps || {}),
        }}
        className="
          o50>.MuiInputBase-input.Mui-disabled w
          (pv19|pt17|hmin56|bxzBB|cF|fw4|ff$2|cr@mouse|crT:f!)>.MuiOutlinedInput-input
          (ph20|(fw4|dn):i!)>(input|textarea)
          (cEC4C4C|o100)>.*-error>(input|textarea):i
          o0>.Mui-focused>(input|textarea):i*2
          o100:h>:not[.Mui-focused]>(input|textarea):i
          o50>.Mui-disabled>(input|textarea):i*3
          pv0>textarea.MuiOutlinedInput-input
          st-4.5>fieldset
          (dn|f15|ov|r8)>.MuiOutlinedInput-root*2
          bgF2:h>.MuiOutlinedInput-root:not[.Mui-disabled]*2
          bg04>.*OutlinedInput-root.*-focused*3
          b2>.*-notchedOutline*2
          ph>.MuiOutlinedInput-multiline
          crD@mouse>.Mui-disabled>.MuiOutlinedInput-input
          bcF.15(>*|:h>*|>.*-focused):not[.*-error]>.*-notchedOutline*2
          (f16|ff$2|fw5|x20y19s90|cA3A7AC:not[.*-error]!)>.*InputLabel
          cF>[data-shrink=true].*InputLabel:not[.*-error]
          (bgFF7070.05|bcEC4C4C)>.*-error>.*-notchedOutline*2
          TextFieldReg dn>input:-webkit-autofill
          f13>.*legendLabelled>span
        "
      />
      {
        limit ? (<div
          className="abs srb5 f10"
        >
          <span
            className={`cF00.active`
            + (length >= limit ? ' active' : '')}
          >{length}</span> / {limit}
        </div>) : null
      }
      {
        props.error ? (<div className="rlv">
          <div
            className="abs sh20 st f12 cEC4C4C fw4 ws ff$2"
          >{helperText || 'Obligatory field'}</div>
        </div>) : null
      }
    </div>
  );
};
